import RecaptchaService from "@/services/RecaptchaService";

export const recaptcha = {
  namespaced: true,
  state: {
    recaptcha: {},
  },
  actions: {
    postRecaptchaValidate({ commit }, payload) {
      return RecaptchaService.PostRecaptchaValidate(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default recaptcha;
